import React from "react";
import styled from "styled-components";
import PretendardText from "../text/pretendardText";

function MainInput({
  type,
  placeholder,
  value,
  onChange,
  onClick,
  onError,
  disabled,
  style,
  dataPlaceholder,
  onKeyDown,
  step,
  helperText,
  maxLength,
}) {
  return (
    <>
      <MainInputWrapper
        type={type}
        disabled={disabled}
        placeholder={placeholder}
        data-placeholder={dataPlaceholder}
        value={value || ""}
        onChange={onChange}
        onClick={onClick}
        onError={onError}
        onKeyDown={onKeyDown}
        step={step}
        maxLength={maxLength}
        style={{
          ...style,
          borderColor: `${onError ? "#FF003D" : "rgba(255, 255, 255, 0.12)"}`,
        }}
      />
      {onError ? <HelperText onError={onError}>{helperText}</HelperText> : ""}
    </>
  );
}

export default MainInput;

const MainInputWrapper = styled.input.attrs((props) => {})`
  width: 100%;
  height: 48px;
  padding: 13px 15px;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: transparent;
  font-family: "Pretendard";
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 21.25px;
  color: #aaa;
  caret: #0077e5;

  &::placeholder {
    font-family: "Pretendard";
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 21.25px;
    color: rgba(181, 181, 181, 0.5);
  }

  &:focus {
    outline: none;
    border: 1px solid #27beff;
  }

  &:disabled {
    outline: none;
    background: #272829;
    color: rgba(181, 181, 181, 0.5);
  }
`;

const HelperText = styled(PretendardText).attrs((props) => {})`
  font-size: 14px;
  font-weight: 500;
  line-height: 22.75px;
  color: ${(props) => (props.onError ? "#FF003D" : "#808991")};
  margin-top: 3px;
`;
